// Pure helpers voor het conceptenoverzicht in "Mijn blogs".
// Een concept is een onafgemaakte sessie (idee al gekozen, nog niet gepubliceerd/verlaten).

export type ConceptState =
  | 'idea_approved'
  | 'article_generated'
  | 'article_approved'
  | 'image_selected';

// Sessie-states die als concept tellen, in wizard-volgorde.
export const CONCEPT_STATES: ConceptState[] = [
  'idea_approved',
  'article_generated',
  'article_approved',
  'image_selected',
];

export interface ConceptSession {
  id: string;
  state: ConceptState;
  selected_title: string | null;
  selected_intro: string | null;
  selected_image_url: string | null;
  article_last_edited: string | null;
  created_at: string;
  // Relatie blog_ideas!approved_idea_id(idea_title): kan object of array zijn.
  blog_ideas?: { idea_title: string | null } | { idea_title: string | null }[] | null;
}

// Statuslabel in gewone taal: waar is de gebruiker gebleven. Vanaf de goedkeuring
// van het artikel kijken we naar de data (titel, intro, beeld), niet naar de
// status-enum: die schuift tussen titel en beeld niet op en gaat niet terug
// als intro's na een titelwijziging opnieuw geschreven worden.
export function conceptStatusLabel(c: ConceptSession): string {
  switch (c.state) {
    case 'idea_approved':
      return 'Idee gekozen';
    case 'article_generated':
      return 'Artikel geschreven';
    case 'article_approved':
    case 'image_selected':
      if (!c.selected_title) return 'Titel kiezen';
      if (!c.selected_intro) return 'Intro kiezen';
      if (!c.selected_image_url) return 'Afbeelding kiezen';
      return 'Klaar om te publiceren';
    default:
      return 'Concept';
  }
}

function ideaTitleOf(c: ConceptSession): string | null {
  const rel = c.blog_ideas;
  if (!rel) return null;
  const row = Array.isArray(rel) ? rel[0] : rel;
  return row?.idea_title ?? null;
}

// Titel met fallback: gekozen titel -> idee-titel -> "Naamloos concept".
export function conceptTitle(c: ConceptSession): string {
  const t = (c.selected_title ?? '').trim();
  if (t) return t;
  const idea = (ideaTitleOf(c) ?? '').trim();
  if (idea) return idea;
  return 'Naamloos concept';
}

// Tijdstip waarop het concept voor het laatst wijzigde (ms).
export function conceptEditedAt(c: ConceptSession): number {
  return new Date(c.article_last_edited ?? c.created_at).getTime();
}

// Nieuwste bovenaan (op laatst bewerkt, val terug op aanmaakdatum). Muteert niet.
export function sortConceptsByEdited(rows: ConceptSession[]): ConceptSession[] {
  return [...rows].sort((a, b) => conceptEditedAt(b) - conceptEditedAt(a));
}
